module.exports = __webpack_public_path__ + "static/media/logo.91896604.svg";